import { EmailService } from './../../services/email.service';
import { SendEmailModel } from './../../models/send-email-model';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  public emailModel: SendEmailModel;
  emailSent = false;
  nameRequired = false;
  fromAddressRequired = false;
  messageRequired = false;
  subjectRequired = false;
  telNoRequired = false;

  constructor(private emailService: EmailService) { }

  onSubmit() {
    let emailValid = true;
    this.nameRequired = false;
    this.fromAddressRequired = false;
    this.messageRequired = false;
    this.subjectRequired = false;
    this.telNoRequired = false;

    this.emailModel = {
      fullName: document.querySelector("#name")['value'],
      email: document.querySelector("#email")['value'],
      message: document.querySelector("#message")['value'],
      subject: 'New website enquiry',
      phone: document.querySelector("#phoneNumber")['value'],
      to: 'info@bloubergphysio.co.za'
    }

    if (!this.emailModel.fullName) {
      this.nameRequired = true;
      emailValid = false;
    }

    if (!this.emailModel.email) {
      this.fromAddressRequired = true;
      emailValid = false;
    }

    if (!this.emailModel.message) {
      this.messageRequired = true;
      emailValid = false;
    }

    if (!this.emailModel.subject) {
      this.subjectRequired = true;
      emailValid = false;
    }

    if (!this.emailModel.phone) {
      this.telNoRequired = true;
      emailValid = false;
    }

    if (emailValid == true) {
      document.querySelector("#name")['value'] = "";
      document.querySelector("#email")['value'] = "";
      document.querySelector("#message")['value'] = "";
      document.querySelector("#phoneNumber")['value'] = "";

      this.emailModel.subject = 'New website enquiry';
      this.emailService.sendEmail(this.emailModel).subscribe({
        next: (res) => {
          this.emailSent = true;
          this.nameRequired = false;
          this.fromAddressRequired = false;
          this.messageRequired = false;
          this.subjectRequired = false;

          //disable the submit button
          document.querySelector("#submitButton")['disabled'] = true;
        },
        error: (err) => {
          console.log(err);
          this.emailSent = false;
          this.nameRequired = false;
          this.fromAddressRequired = false;
          this.messageRequired = false;
          this.subjectRequired = false;
        }
      })
    }


  }
}
